import React from 'react';
import { FiCheck, FiClock, FiX, FiAlertCircle, FiSend, FiMail, FiRefreshCw } from 'react-icons/fi';

const STATUS_CONFIG = {
  // Document statuses
  pending:   { label: 'Pending',    color: 'bg-amber-50 text-amber-700 border-amber-100', icon: FiClock },
  generated: { label: 'Generated',  color: 'bg-brand-50 text-brand-700 border-brand-100', icon: FiCheck },
  error:     { label: 'Error',      color: 'bg-red-50 text-red-700 border-red-100',       icon: FiAlertCircle },
  
  // Email statuses
  queued:    { label: 'Queued',     color: 'bg-slate-100 text-slate-600 border-slate-200', icon: FiClock },
  sending:   { label: 'Sending',    color: 'bg-sky-50 text-sky-700 border-sky-100',       icon: FiRefreshCw },
  sent:      { label: 'Sent',       color: 'bg-emerald-50 text-emerald-700 border-emerald-100', icon: FiCheck },
  delivered: { label: 'Delivered',  color: 'bg-emerald-50 text-emerald-700 border-emerald-100', icon: FiCheck },
  opened:    { label: 'Opened',     color: 'bg-brand-50 text-brand-700 border-brand-100', icon: FiMail },
  failed:    { label: 'Failed',     color: 'bg-red-50 text-red-700 border-red-100',       icon: FiX },
  bounced:   { label: 'Bounced',    color: 'bg-red-50 text-red-700 border-red-100',       icon: FiAlertCircle },
  
  // Certificate statuses
  active:    { label: 'Active',     color: 'bg-emerald-50 text-emerald-700 border-emerald-100', icon: FiCheck },
  revoked:   { label: 'Revoked',    color: 'bg-red-50 text-red-700 border-red-100',       icon: FiX },
  archived:  { label: 'Archived',   color: 'bg-amber-50 text-amber-700 border-amber-100', icon: FiClock },
  renewed:   { label: 'Renewed',    color: 'bg-sky-50 text-sky-700 border-sky-100',       icon: FiRefreshCw },
  reissued:  { label: 'Reissued',   color: 'bg-violet-50 text-violet-700 border-violet-100', icon: FiSend },

  // Candidate statuses
  Applied:     { label: 'Applied',     color: 'bg-slate-100 text-slate-600 border-slate-200', icon: FiClock },
  Shortlisted: { label: 'Shortlisted', color: 'bg-amber-50 text-amber-700 border-amber-100', icon: FiClock },
  Selected:    { label: 'Selected',    color: 'bg-brand-50 text-brand-700 border-brand-100', icon: FiCheck },
  Active:      { label: 'Active',      color: 'bg-emerald-50 text-emerald-700 border-emerald-100', icon: FiCheck },
  Completed:   { label: 'Completed',   color: 'bg-slate-100 text-slate-600 border-slate-200', icon: FiCheck },
  Dropped:     { label: 'Dropped',     color: 'bg-red-50 text-red-700 border-red-100',       icon: FiX },
  Rejected:    { label: 'Rejected',    color: 'bg-red-50 text-red-700 border-red-100',       icon: FiX },
};

export default function StatusBadge({ status, className = '' }) {
  const config = STATUS_CONFIG[status] || {
    label: status || 'Unknown',
    color: 'bg-slate-100 text-slate-600 border-slate-200',
    icon: FiClock,
  };

  const Icon = config.icon;

  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-semibold border ${config.color} ${className}`}>
      <Icon className="w-3 h-3 flex-shrink-0" />
      {config.label}
    </span>
  );
}
